<template>
  <div class="products-container">
    <!-- Hero Section -->
      <section class="hero">
        <div class="hero-background">
          <img :src="Images.products.background_1" alt="Background" class="hero-bg-image">
          <div class="hero-overlay"></div>
        </div>
        <div class="hero-content">
          <h1 class="hero-title">产品与服务</h1>
        </div>
      </section>
    
    <main class="products-content">
      <!-- 面包屑导航 -->
      <section class="breadcrumb-section">
        <div class="container">
          <nav class="breadcrumb">
            <router-link to="/home" class="breadcrumb-item">首页</router-link>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-item active">产品与服务</span>
          </nav>
        </div>
      </section>
      
      <!-- 自研APP展示区 -->
      <section class="app-section">
        <div class="container">
          <div class="section-title">
            <h2 class="main-title">端侧应用创新方案＋自研APP</h2>
            <p class="subtitle">从硬件设计到软件开发，从模型训练到产品落地，提供AI全栈技术服务</p>
          </div>
          
          <div class="app-showcase">
            <div class="app-image">
              <img :src="Images.products.app" alt="Joy Audio App">
            </div>
            <div class="app-description">
              <p class="app-intro"><span class="app-title">Joy Audio App</span> 是基于<strong>豆包大模型 + 火山引擎端侧 AI</strong>打造的一站式智能语音处理平台，核心为用户提供高效、精准的语音转写、翻译与智能交互服务，覆盖商务、学习、生活等全场景。</p>
              <ul class="app-features">
                <li class="feature-item">
                  <strong>录音转写：</strong>
                  <span>支持现场、会议、通话录音，实时文字 + 智能摘要，还能多语言识别；</span>
                </li>
                <li class="feature-item">
                  <strong>实时翻译：</strong>
                  <span>6种模式（同传译诗、通话翻译等），覆盖27种语言，响应快、准确率高；</span>
                </li>
                <li class="feature-item">
                  <strong>智能对话：</strong>
                  <span>多角色陪伴 + 口语陪练，能答疑、纠错，适合学习和日常互动。</span>
                </li>
              </ul>
              
              <router-link to="download/" class="view-more-btn">查看更多</router-link>
            </div>
          </div>
        </div>
      </section>

      <!-- 全方位AI技术解决方案 -->
      <section class="solutions-section">
        <div class="container">
          <div class="section-title">
            <h2 class="main-title">全方位AI技术解决方案</h2>
            <p class="subtitle">从硬件设计到软件开发，从模型训练到产品落地，提供AI全栈式技术服务</p>
          </div>

          <div class="solutions-grid">
            <div class="solution-card">
              <div class="solution-icon">
                <img :src="Images.products.icon_1" alt="AI软硬件一体解决方案" class="solution-icon-img">
              </div>
              <h3 class="solution-title">AI软硬件一体解决方案</h3>
              <div class="solution-content">
                <p class="core-content"><strong>核心内容：</strong>覆盖芯片适配→软件开发→系统集成→量产交付的全栈技术支持，将AI大模型与硬件端深度融合，打造高性能智能终端。</p>
                <p class="application-scenario"><strong>适配场景：</strong>AI耳机、智能眼镜、便携音响、高端机器人、IP玩具等多类型消费电子产品。</p>
              </div>
              <a href="/download" class="custom-solution-btn">
                <span>定制方案</span>
                <img :src="Images.products.to_right" alt="查看更多" class="btn-icon">
              </a>
            </div>

            <div class="solution-card">
              <div class="solution-icon">
                <img :src="Images.products.icon_2" alt="彩屏蓝牙消费电子解决方案" class="solution-icon-img">
              </div>
              <h3 class="solution-title">彩屏蓝牙消费电子解决方案</h3>
              <div class="solution-content">
                <p class="core-content"><strong>核心内容：</strong>以创新UI设计为核心，融合蓝牙5.0/WIFI 6高速连接技术，重构消费电子交互体验，让操作更智能、视觉更出彩。</p>
                <p class="application-scenario"><strong>适配场景：</strong>WIFI蓝牙耳机、AI陪伴机器人、智能IP玩具、桌面便携音响。</p>
              </div>
              <a href="/download" class="custom-solution-btn">
                <span>定制方案</span>
                <img :src="Images.products.to_right" alt="查看更多" class="btn-icon">
              </a>
            </div>

            <div class="solution-card">
              <div class="solution-icon">
                <img :src="Images.products.icon_3" alt="AI豆包大模型赋能服务" class="solution-icon-img">
              </div>
              <h3 class="solution-title">AI豆包大模型赋能服务</h3>
              <div class="solution-content">
                <p class="core-content"><strong>核心内容：</strong>基于火山引擎豆包大模型，提供「智能交互+实时功能+双核芯能力」，让终端设备具备拟人化沟通与高效端侧能力。</p>
                <p class="application-scenario"><strong>适配场景：</strong>情感聊天、口语陪练、声纹识别、会议/课堂AI摘要、多语种同声传译、面对面翻译、意图情感识别。</p>
              </div>
              <a href="/download" class="custom-solution-btn">
                <span>定制方案</span>
                <img :src="Images.products.to_right" alt="查看更多" class="btn-icon">
              </a>
            </div>
          </div>
        </div>
      </section>

      <!-- 我们的产品系列 -->
      <section class="products-series">
        <div class="container2">
          <div class="section-title">
            <h2 class="main-title">我们的产品系列</h2>
            <p class="subtitle">把大模型装进每一台设备，让智能融入每一个场景</p>
          </div>
          <div class="products-grid">
            <div class="product-card">
              <div class="product-image">
                <img :src="Images.products.product_1" alt="AI耳机">
              </div>
              <div class="product-info">
                <h3 class="product-name">AI耳机</h3>
                <p class="product-tag">个性化UI专属定制</p>
                <router-link to="/productDetail" class="product-link">了解更多 <img :src="Images.products.to_right" alt="查看更多" class="btn-icon"></router-link>
              </div>
            </div>
            <div class="product-card">
              <div class="product-image">
                <img :src="Images.products.product_2" alt="AI眼镜">
              </div>
              <div class="product-info">
                <h3 class="product-name">AI眼镜</h3>
                <p class="product-tag">个性化UI专属定制</p>
                <router-link to="/productDetail" class="product-link">了解更多 <img :src="Images.products.to_right" alt="查看更多" class="btn-icon"></router-link>
              </div>
            </div>
            <div class="product-card">
              <div class="product-image">
                <img :src="Images.products.product_3" alt="AI智能音箱">
              </div>
              <div class="product-info">
                <h3 class="product-name">AI智能音箱</h3>
                <p class="product-tag">个性化UI专属定制</p>
                <router-link to="/productDetail" class="product-link">了解更多 <img :src="Images.products.to_right" alt="查看更多" class="btn-icon"></router-link>
              </div>
            </div>
            <div class="product-card">
              <div class="product-image">
                <img :src="Images.products.product_4" alt="AI桌面机器人">
              </div>
              <div class="product-info">
                <h3 class="product-name">AI桌面机器人</h3>
                <p class="product-tag">个性化UI专属定制</p>
                <router-link to="/productDetail" class="product-link">了解更多 <img :src="Images.products.to_right" alt="查看更多" class="btn-icon"></router-link>
              </div>
            </div>
            <div class="product-card">
              <div class="product-image">
                <img :src="Images.products.product_5" alt="AI录音卡片">
              </div>
              <div class="product-info">
                <h3 class="product-name">AI录音卡片</h3>
                <p class="product-tag">个性化UI专属定制</p>
                <router-link to="/productDetail" class="product-link">了解更多 <img :src="Images.products.to_right" alt="查看更多" class="btn-icon"></router-link>
              </div>
            </div>
            <div class="product-card">
              <div class="product-image">
                <img :src="Images.products.product_6" alt="AI智能闹钟">
              </div>
              <div class="product-info">
                <h3 class="product-name">AI智能闹钟</h3>
                <p class="product-tag">个性化UI专属定制</p>
                <router-link to="/productDetail" class="product-link">了解更多 <img :src="Images.products.to_right" alt="查看更多" class="btn-icon"></router-link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 为什么选择我们的AI服务 -->
      <section class="why-choose-us">
        <div class="container">
          <div class="section-title">
            <h2 class="main-title">为什么选择竟加技术的AI服务？</h2>
            <p class="subtitle">把大模型装进每一台设备，让智能融入每一个场景</p>
          </div>
          
          <div class="advantages-carousel">
            <div class="carousel-container">
              <div class="carousel-content">
                <div class="advantage-item active">
                  <div class="advantage-image">
                    <img :src="Images.products.AI_1" alt="芯片层大模型适配">
                  </div>
                  <div class="advantage-info">
                    <h3 class="advantage-title">芯片层大模型适配</h3>
                    <div class="advantage-divider"></div>
                    <p class="advantage-description">芯片级算法优化+硬件深度适配，让AI大模型在终端设备上高效运行，性能领先同行30%</p>
                  </div>
                </div>
                
                <div class="advantage-item">
                  <div class="advantage-image">
                    <img :src="Images.products.AI_2" alt="全流程技术支持">
                  </div>
                  <div class="advantage-info">
                    <h3 class="advantage-title">全流程技术支持</h3>
                    <div class="advantage-divider"></div>
                    <p class="advantage-description">覆盖产品 ID 设计、研发测试、量产交付至售后维护全流程，提供一体化技术服务，助力产品高效落地。</p>
                  </div>
                </div>
                
                <div class="advantage-item">
                  <div class="advantage-image">
                    <img :src="Images.products.AI_3" alt="顶级生态合作">
                  </div>
                  <div class="advantage-info">
                    <h3 class="advantage-title">顶级生态合作</h3>
                    <div class="advantage-divider"></div>
                    <p class="advantage-description">与杰理 / 恒玄 / 海思等芯片原厂、火山引擎等云厂商深度合作，共建技术协作生态，夯实方案底层技术根基。</p>
                  </div>
                </div>
                
                <div class="advantage-item">
                  <div class="advantage-image">
                    <img :src="Images.products.AI_4" alt="专业团队保障">
                  </div>
                  <div class="advantage-info">
                    <h3 class="advantage-title">专业团队保障</h3>
                    <div class="advantage-divider"></div>
                    <p class="advantage-description">覆盖研发、测试、硬件、设计全链条技术环节，精准匹配业务场景，高效落地定制化需求</p>
                  </div>
                </div>
              </div>
            </div>
            
            <button class="carousel-arrow prev-arrow" @click="prevSlide">&lt;</button>
            <button class="carousel-arrow next-arrow" @click="nextSlide">&gt;</button>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { Images } from '@/utils/imageLoader';

export default {
  name: 'ProductsView',
  data() {
    return {
      currentIndex: 0,
      totalItems: 4,
      Images
    }
  },
  methods: {
    // 轮播方法
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateSlidePosition();
      }
    },
    nextSlide() {
      if (this.currentIndex < this.totalItems - 1) {
        this.currentIndex++;
        this.updateSlidePosition();
      }
    },
    updateSlidePosition() {
      const carouselContent = document.querySelector('.carousel-content');
      const slideWidth = carouselContent.querySelector('.advantage-item').offsetWidth;
      carouselContent.style.transform = `translateX(-${this.currentIndex * slideWidth}px)`;
      
      // 更新active类
      document.querySelectorAll('.advantage-item').forEach((item, index) => {
        item.classList.toggle('active', index === this.currentIndex);
      });
    }
  },
  mounted() {
    // 页面加载完成后初始化轮播位置
    this.updateSlidePosition();
  }
}
</script>

<style scoped>
/* Hero Section */
.hero {
  position: relative;
  height: 72.5vh;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: hidden;
  margin-top: 80px;
  padding-top: 260px;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.hero-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5));
}

.hero-content {
  text-align: left;
  color: white;
  z-index: 1;
  max-width: 1000px;
  padding: 0 80px;
  margin-left: 290px;
  margin-top: 100px;
}

.hero-title {
  font-size: 90px;
  font-weight: bold;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 2px;
  line-height: 1.2;
  color: #FFFFFF;
}

/* 面包屑导航 */
.breadcrumb-section {
  padding: 20px 0;
  background-color: #fff;
}


.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.breadcrumb-item {
  color: #666;
  text-decoration: none;
}

.breadcrumb-item:hover {
  color: #ff6b00;
}

.breadcrumb-item.active {
  color: #333;
  font-weight: 500;
}

.breadcrumb-separator {
  color: #999;
}

/* APP展示区 */
.app-section {
  padding: 80px 0;
  background-color: #fff;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title .main-title {
  font-size: 28px;
  font-weight: bold;
  color: #000;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

.section-title .subtitle {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  max-width: 800px;
  margin: 0 auto;
}

.app-showcase {
  display: flex;
  align-items: center;
  gap: 40px;
  justify-content: center;
  padding: 0 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.app-image {
  flex: 0 0 auto;
}

.app-image img {
  width: 540px;
  height: auto;
  object-fit: contain;
}

.app-description {
  flex: 1;
  max-width: 620px;
  padding: 0;
}

.app-title {
  font-size: 18px;
  font-weight: bold;
  color: #ff6b00;
  margin-bottom: 16px;
}

.app-intro {
  font-size: 16px;
  color: #000;
  line-height: 2.2;
  margin-bottom: 20px;
}

.app-features {
  list-style: none;
  padding: 0;
  margin: 0 0 24px 0;
}

.feature-item {
  font-size: 16px;
  color: #000;
  line-height: 2.2;
  margin-bottom: 8px;
}

.feature-item strong {
  color: #000;
  font-weight: bold;
}

.view-more-btn {
  background-color: #fff;
  color: #ff6b00;
  border: 1px solid #ff6b00;
  padding: 8px 24px;
  font-size: 14px;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 400;
  border-radius: 4px;
}

.view-more-btn:hover {
  background-color: #ff6b00;
  color: #fff;
}

/* 通用样式 */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}
/* 通用样式 */
.container2 {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
/* 全方位AI技术解决方案 */
.solutions-section {
  padding: 80px 0;
  background-color: #fff;
}

.solutions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 30px;
  margin-top: 60px;
}

.solution-card {
  background-color: #F8F8FA;
  border-radius: 0;
  padding: 30px;
  box-sizing: border-box;
  transition: all 0.3s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  position: relative;
}

.solution-card::before {
  content: '';
  position: absolute;
  top: -3px;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #FF9500, #FF5A00);
}

.solution-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.solution-icon {
  margin-bottom: 20px;
}

.solution-icon-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  display: block;
}

.solution-title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 20px;
  line-height: 1.4;
}

.solution-content {
  margin-bottom: 24px;
}

.core-content {
  font-size: 14px;
  color: #000;
  line-height: 1.8;
  margin-bottom: 16px;
}

.application-scenario {
  font-size: 14px;
  color: #000;
  line-height: 1.8;
}

.custom-solution-btn {
  font-size: 14px;
  color: #ff6b00;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.custom-solution-btn:hover {
  color: #e55a00;
  text-decoration: none;
}

.btn-icon {
  width: 20px;
  height: 14px;
  object-fit: contain;
  display: block;
}

/* 我们的产品系列 */
.products-series {
  padding: 80px 0;
  background-color: #fff;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-top: 60px;
}

.product-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #F8F8FA;
  padding: 30px;
  box-sizing: border-box;
  transition: all 0.3s;
  position: relative;
  min-height: 260px;
}

.product-card:hover {
  border-color: #ff6b00;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.product-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.product-name {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 10px;
}

.product-tag {
  font-size: 14px;
  color: #999;
  margin-bottom: 20px;
}

.product-link {
  font-size: 14px;
  color: #ff6b00;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s;
}

.product-link:hover {
  color: #e55a00;
}

.product-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
}

.product-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* 为什么选择我们的AI服务 */
.why-choose-us {
  padding: 80px 0;
  background-color: #fff;
}

.advantages-carousel {
  position: relative;
  max-width: 1400px;
  margin: 0 auto;
  overflow: hidden;
}

.carousel-container {
  overflow: hidden;
}

.carousel-content {
  display: flex;
  transition: transform 0.5s ease;
}

.advantage-item {
  flex: 0 0 100%;
  display: flex;
  align-items: flex-start;
  gap: 60px;
  padding: 0 40px;
  box-sizing: border-box;
}

.advantage-image {
  flex: 0 0 580px;
  height: 420px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.advantage-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.advantage-info {
  flex: 1;
}

.advantage-title {
  font-size: 30px;
  font-weight: bold;
  color: #000;
  margin-bottom: 10px;
}

.advantage-divider {
  width: 120px;
  height: 6px;
  background: linear-gradient(90deg, #FF9500, #FF5A00);
  margin-bottom: 32px;
}

.advantage-description {
  font-size: 16px;
  color: #666;
  line-height: 2.4;
}

.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 50%;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-arrow:hover {
  background-color: rgba(0, 0, 0, 0.2);
  color: #333;
}

.prev-arrow {
  left: 0;
}

.next-arrow {
  right: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .advantage-item {
    flex-direction: column;
    text-align: center;
    gap: 30px;
    padding: 0 20px;
  }
  
  .advantage-image {
    flex: 0 0 auto;
    width: 200px;
    height: 150px;
  }
  
  .advantage-divider {
    margin-left: auto;
    margin-right: auto;
  }
  
  .carousel-arrow {
    width: 30px;
    height: 30px;
    font-size: 16px;
  }
}
</style>